import { message } from 'antd';
import React from 'react';
import { useEffect } from 'react';
import { findSiteData } from "../Utils/valueGet";
var YsfService = function YsfService(props) {
  var _findSiteData, _findSiteData2, _findSiteData3, _onError;
  var _props$userDate = props.userDate,
    userDate = _props$userDate === void 0 ? {} : _props$userDate,
    _props$siteData = props.siteData,
    siteData = _props$siteData === void 0 ? {} : _props$siteData,
    children = props.children,
    onClick = props.onClick,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style,
    onError = props.onError,
    onYsfReady = props.onYsfReady,
    onYsfSuccess = props.onYsfSuccess;
  var _ref = userDate || {},
    code = _ref.code,
    email = _ref.email,
    idCardNo = _ref.idCardNo,
    name = _ref.name,
    mobile = _ref.mobile;
  // 站点名称
  var siteNme = findSiteData(siteData, 'name', {
    findKey: 'baseInfo'
  }) || '';
  // 客服组
  var groupId = ((_findSiteData = findSiteData(siteData, 'customer_service_group_id')) === null || _findSiteData === void 0 ? void 0 : _findSiteData.value) || '';
  // 是否启用机器人
  var robotShuntSwitch = Number((_findSiteData2 = findSiteData(siteData, 'enable_robot')) === null || _findSiteData2 === void 0 ? void 0 : _findSiteData2.value) || 0;
  // 对话框模板
  var templateId = Number((_findSiteData3 = findSiteData(siteData, 'dialog_template_id')) === null || _findSiteData3 === void 0 ? void 0 : _findSiteData3.value) || '';
  // 对话框打开失败
  (_onError = onError) !== null && _onError !== void 0 ? _onError : onError = function onError() {
    message.destroy();
    message.error('操作失败，请刷新重试', 3);
  };
  var configUsr = {
    // 用户标识，不传表示匿名用户
    uid: code,
    // 用户名称
    name: name,
    // 用户邮箱
    email: email,
    // 用户手机号
    mobile: mobile,
    // 用户组id
    groupid: groupId,
    // 机器人优先开关
    robotShuntSwitch: robotShuntSwitch,
    // 企业常见问题模板id
    // qtype: '',
    //登录用户其他信息
    data: JSON.stringify([{
      index: 1,
      key: 'sidName',
      label: '站点名称',
      value: siteNme
    }, {
      index: 2,
      key: 'sid',
      label: '站点ID',
      value: siteData === null || siteData === void 0 ? void 0 : siteData.sid
    }, {
      key: 'id_cardNo',
      label: '身份证号',
      value: idCardNo
    }

    // { "index": 5, "key": "reg_date", "label": "注册日期", "value": "2015-11-16" },
    // { "index": 6, "key": "last_login", "label": "上次登录时间", "value": "2015-12-22 15:38:54" }
    ]),

    // 导航头是否显示返回按钮
    isShowBack: true,
    level: 1,
    success: function success() {
      var _window, _window$ysf;
      onYsfSuccess ? onYsfSuccess === null || onYsfSuccess === void 0 ? void 0 : onYsfSuccess() : message.destroy();
      (_window = window) === null || _window === void 0 || (_window$ysf = _window.ysf) === null || _window$ysf === void 0 || _window$ysf.call(_window, 'open', {
        templateId: templateId
      });
    },
    error: function error() {
      var _onError2;
      (_onError2 = onError) === null || _onError2 === void 0 || _onError2();
    }
  };
  var loadScript = function loadScript() {
    if (!document.getElementById('qiyukf')) {
      var scriptDom = document.createElement('script');
      scriptDom.charset = 'utf-8';
      scriptDom.src = "https://qiyukf.com/script/6678a159c701ad9647a6dc57bfacf81a.js?sdkTemplateId=".concat(templateId, "&hidden=1");
      scriptDom.id = 'qiyukf';
      scriptDom.onload = function () {
        scriptDom.setAttribute('done', '1');
      };
      var head = document.getElementsByTagName('head')[0];
      head.appendChild(scriptDom);
    }
  };
  // 点击客服按钮的事件
  var onClickServer = function onClickServer() {
    var _window2, _window2$ysf, _window3, _window3$ysf;
    // 准备打开
    (_window2 = window) === null || _window2 === void 0 || (_window2$ysf = _window2.ysf) === null || _window2$ysf === void 0 || _window2$ysf.call(_window2, 'onready', function () {
      onYsfReady ? onYsfReady === null || onYsfReady === void 0 ? void 0 : onYsfReady() : message.loading('正在为您联系客服,请稍后', 0);
    });
    (_window3 = window) === null || _window3 === void 0 || (_window3$ysf = _window3.ysf) === null || _window3$ysf === void 0 || _window3$ysf.call(_window3, 'config', configUsr);
    onClick && (onClick === null || onClick === void 0 ? void 0 : onClick());
  };
  useEffect(function () {
    loadScript();
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClickServer,
    style: style
  }, children && children);
};
export default YsfService;